// extracted by mini-css-extract-plugin
export default {"preloader":"preloader_preloader__xDmHq","spinner":"preloader_spinner__BFtAt","spin":"preloader_spin__Qm7lg"};